// extracted by mini-css-extract-plugin
export default {"gameOver":"gameover_gameOver__huBqA","drop":"gameover_drop__TrOK1","gameOverBtn":"gameover_gameOverBtn__bwffA","appear":"gameover_appear__Vp-rT"};